import { render, staticRenderFns } from "./Contention.vue?vue&type=template&id=90d621ae"
import script from "./Contention.vue?vue&type=script&lang=js"
export * from "./Contention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports